/**
 * Crea las fichas que se colocan sobre la alfombra
 * @param {*} scene
 */
export function crearFichasAlfombra(scene) {
  // ficha10
  scene.anims.create({
    key: 'fichaAlfombra10Animada',
    frames: scene.anims.generateFrameNumbers('fichaAlfombra10', {
      start: 0,
      end: 19,
    }),
    frameRate: 10,
    repeat: -1,
  });

  // ficha20
  scene.anims.create({
    key: 'fichaAlfombra20Animada',
    frames: scene.anims.generateFrameNumbers('fichaAlfombra20', {
      start: 0,
      end: 19,
    }),
    frameRate: 10,
    repeat: -1,
  });

  // ficha50
  scene.anims.create({
    key: 'fichaAlfombra50Animada',
    frames: scene.anims.generateFrameNumbers('fichaAlfombra50', {
      start: 0,
      end: 19,
    }),
    frameRate: 10,
    repeat: -1,
  });

  // ficha100
  scene.anims.create({
    key: 'fichaAlfombra100Animada',
    frames: scene.anims.generateFrameNumbers('fichaAlfombra100', {
      start: 0,
      end: 19,
    }),
    frameRate: 10,
    repeat: -1,
  });

  // fichaComodin
  scene.anims.create({
    key: 'fichaAlfombraComodinAnimada',
    frames: scene.anims.generateFrameNumbers('fichaAlfombraComodin', {
      start: 0,
      end: 19,
    }),
    frameRate: 10,
    repeat: -1,
  });

  // ficha para seguro de jugador 1 cargada por defecto (comodin) e invisible
  scene.fichaJugador1Seguro = scene.add
    .sprite(340, 304, 'fichaAlfombraComodin')
    .setVisible(false);
  scene.fichaJugador1Seguro.play('fichaAlfombraComodinAnimada');

  // ficha para mano 2 de jugador 1 cargada por defecto (comodin) e invisible
  scene.fichaJugador1Mano2 = scene.add
    .sprite(660, 304, 'fichaAlfombraComodin')
    .setVisible(false);
  scene.fichaJugador1Mano2.play('fichaAlfombraComodinAnimada');
}
